/**
 * 缓存第一次方法调用结果，避免相同时间调用多次
 * @template T
 * @param {T} fn, Function to be memorize.
 * @param {number} timeout, seconds until wait lock timeout, default 1 minutes.
 * @return {T}
 */
module.exports = {
  memorizeFn(fn, timeout = 60) {
    if (typeof fn !== "function") {
      throw new TypeError(
        "Must pass a function as the function to be memoized"
      );
    }

    let calledTime;
    let memorized;
    return function (...args) {
      const now = Date.now();
      if (calledTime) {
        // 没超过时间则返回缓存的值
        if (now - calledTime < timeout * 1000) {
          return memorized;
        }
      }
      calledTime = now;

      let currentReturn = fn.apply(this, args);

      if (memorized && currentReturn && currentReturn.then) {
        // 如果是Promise，先返回缓存的内容，然后在Promise结束时更新缓存
        currentReturn.then((res) => {
          // 更新缓存
          memorized = res;
          return res;
        });

        return memorized;
      } else {
        // 非 Promise 则直接返回
        memorized = currentReturn;
        return currentReturn;
      }
    };
  },
};
